import { createContext } from 'react'

const IsNavDrawerHiddenContext = createContext()

export default IsNavDrawerHiddenContext
